$(document).ready(function () {
    var $sliders = $('.horizontal-article-highlights'),
        amountPerLine = 3,
        avoidScrolling = false,
        startX,
        startY;

    document.addEventListener(
        'touchmove',
        function (e) {
            if (avoidScrolling) e.preventDefault();
        },
        { passive: false }
    );

    $sliders.each(function (i) {
        $slider = $sliders.eq(i);
        if ($slider.find('li').length <= amountPerLine) return;

        $slider
            .find('ul')
            .on('touchstart', function (e) {
                startX = e.originalEvent.touches[0].clientX;
                startY = e.originalEvent.touches[0].clientY;
                avoidScrolling = false;
            })
            .on('touchend', function (e) {
                avoidScrolling = false;
            })
            .on('touchmove', function (e) {
                var currentX = e.originalEvent.changedTouches[0].clientX,
                    currentY = e.originalEvent.changedTouches[0].clientY,
                    diffX = Math.abs(startX - currentX),
                    diffY = Math.abs(startY - currentY);

                if (diffY < diffX && diffY > 5) {
                    avoidScrolling = true;
                }
            })
            .slick({
                slide: 'li',
                infinite: false,
                dots: false,
                swipe: true,
                speed: 300,
                slidesToShow: amountPerLine,
                slidesToScroll: amountPerLine,
                arrows: true,
                autoplay: false,
                adaptiveHeight: false,
                variableWidth: false,
                nextArrow: $slider.find('.next'),
                prevArrow: $slider.find('.prev'),
                responsive: [
                    {
                        breakpoint: 750,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                ],
            });
    });
});
